import { ToastActions, ToastActionTypes } from '../actions';

export interface ToastMessage {
  type: string;
  message: string;
}

export interface State {
  messagesList: Array<ToastMessage>;
}

export const initialState: State = {
  messagesList: [],
};

export function reducer(
  state: any = initialState,
  action: ToastActions
): State {
  switch (action.type) {
    case ToastActionTypes.ADD_SUCCESS: {
      return {
        ...state,
        messagesList: [...state.messagesList, action.payload],
      };
    }

    case ToastActionTypes.DELETE_SUCCESS: {
      return {
        ...state,
        messagesList: [
          ...state.messagesList.filter((toast: ToastMessage) => {
            return toast.message !== action.payload.message;
          }),
        ],
      };
    }

    default: {
      return state;
    }
  }
}

export const getToastMessages = (state: State) => state.messagesList;
